import '@ui/components/molecules/BackLink';
import '@ui/components/molecules/ErrorSummary';
import '@ui/components/organisms/NhsFooter';
import '@ui/components/organisms/NhsHeader';
import '@ui/AppShell';
import '@styles/global.scss';
import { createContainer } from '@infrastructure/di/container';
import { appShellTag } from '@ui/elementTags';
import type { AppShell } from '@ui/AppShell';

const bootstrap = async (): Promise<void> => {
	document.body.classList.add('js-enabled');
	if ('noModule' in HTMLScriptElement.prototype) {
		document.body.classList.add('nhsuk-frontend-supported');
	}

	const container = createContainer();
	try {
		await container.nhsAppGateway.detectRuntime();
	} catch {
		// Allow the shell's runtime-dependent flows to handle NHS App API failures.
	}
	const shell = document.createElement(appShellTag) as AppShell;
	shell.sessionLifecycleController = container.sessionLifecycleController;

	document.body.replaceChildren(shell);

	await shell.updateComplete;
	await shell.waitForShellInitialization();
	await container.sessionLifecycleController.initialize();
	container.router.start(shell.getOutlet());
};

void bootstrap();
